export default __webpack_public_path__ + "static/blog_post-0a32df1855ab4923d5e853cf1bbe0975.gif";